import React, { useState, useEffect } from "react";
import {
  DateInput,
  TextInput,
  SelectInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import Table from "../../components/common/table/Table";
import { useDispatch, useSelector } from "react-redux";
import ExcelExport from "../../components/common/ui/Export/ExcelExport.jsx";
import { documentsActions, masterActions, authActions } from "../../_store";
import generateXlsx from "../../components/common/export/generateXlsx.js";
import { Popup } from "../../components/common/ui/NotificationModal/Popup.js";
import { history } from "../../_helpers";
import deleteicon from "../../assets/svg/delete-icon.svg";
import downloadicon from "../../assets/svg/download.svg";
import Activeicon from "../../assets/svg/approved.svg";
import Inactiveicon from "../../assets/svg/inactive-user.svg";
import CustomLoader from "../../components/common/ui/Loader";
import { MenuItem, StoredProcedures } from "../../_helpers/enumerator";
import Swal from "sweetalert2";
import { fDate, MinDate, Today } from "../../utils/formatTime";
import { useRef } from "react";
import uploadicon from "../../assets/svg/btn_icons/create-btn-icon.svg";

function Documents() {
  const dispatch = useDispatch();
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );
  const { loaddata, loading, deleteResponse, documentList, documentSearch } =
    useSelector((state) => state.documents);
  const [isloading, setisloading] = React.useState(false);
  //Management User Access Permission selector
  const userAccessPermission = useSelector(
    (state) => state.auth.managementUserAccessPermission
  );
  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const [showSearchFields, setShowSearchFields] = useState(false);
  const user = useSelector((x) => x.auth.user);
  const { facilityDropDown, downloadResponse } = useSelector((x) => x.master);
  const { podStatusOptions } = useSelector((state) => state.dropdownOptions);
  const [formData, setFormData] = useState({
    title: "",
    activeStatus: 2,
    fromDate: "",
    toDate: "",
    pageNo: 1,
    rowCountPerPage: 10,
    SortField: "",
    facilityID: commonFacilityCode,
  });
  // store facility Code
  const [facilityCode, setfacilityCode] = useState("");
  // store Access Permission list
  const [accessPermission, setaccessPermission] = useState([]);

  // Hide or Show Upload btn
  const shouldShowBtnUpload =
    Array.isArray(accessPermission) && accessPermission.length > 0
      ? accessPermission.some(
        (item) =>
          item?.SubMenuName === "Upload" && item?.SubMenuActiveStatus === 1
      )
      : true;

  // Enabled or Disabled Delete btn in grid
  const shouldEnableBtnDelete =
    Array.isArray(accessPermission) && accessPermission.length > 0
      ? accessPermission.some(
        (item) =>
          item?.SubMenuName === "Delete" && item?.SubMenuActiveStatus === 1
      )
      : true;

  /// filter the Facility Label
  const targetLabel = facilityDropDown?.find(
    (item) => item?.value === parseInt(commonFacilityCode)
  )?.label;
  useEffect(() => {
    if (commonFacilityCode) {
      dispatch(
        documentsActions?.setDocumentSearch({
          ...documentSearch,
          facilityID: commonFacilityCode,
        })
      );
    }
  }, [commonFacilityCode]);
  useEffect(() => {
    setfacilityCode(targetLabel || "");
  }, [loaddata, targetLabel]);

  // Load facility dropdown on initial
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, [dispatch]);

  useEffect(() => {
    if (commonFacilityCode === 0) return;
    const searchData = { ...documentSearch };
    searchData.facilityID = commonFacilityCode;
    dispatch(documentsActions?.setDocumentSearch(searchData));
    setisloading(true);
    dispatch(documentsActions.LoadDocumentList(searchData))
      .then((result) => {
        setisloading(false);
        // if (result?.payload?.DataList?.length === 0) {
        //   const searchData = { ...documentSearch };
        //   searchData.pageNo = 1;
        //   searchData.rowCountPerPage = 10;
        //   searchData.facilityID = commonFacilityCode;
        //   dispatch(documentsActions?.setDocumentSearch(searchData));
        //   dispatch(documentsActions.LoadDocumentList(searchData));
        // }
      })
      .catch((err) => {
        showToastNotification(err?.message, "error");
      });
  }, [
    //documentSearch.facilityID,
    documentSearch.activeStatus,
    commonFacilityCode,
    isPageReloading,
  ]);


  ////delete response
  useEffect(() => {
    switch (deleteResponse?.IsSucceed) {
      case 1:
        const searchData = { ...documentSearch };
        // searchData.pageNo = 1;
        // searchData.rowCountPerPage = 10;
        // searchData.facilityID = commonFacilityCode;
        // dispatch(documentsActions?.setDocumentSearch(searchData));
        dispatch(documentsActions.LoadDocumentList(searchData))
          .then((result) => {
            if (result?.payload?.DataList?.length === 0) {
              searchData.pageNo = 1;
              searchData.rowCountPerPage = 10;
              searchData.facilityID = commonFacilityCode;
              dispatch(documentsActions?.setDocumentSearch(searchData));
              dispatch(documentsActions.LoadDocumentList(searchData));
            }
          })
          .catch((err) => { });
        showToastNotification("Document deleted successfully", "success");
        dispatch(documentsActions.clearDeleteDocument());
        break;

      case -1:
        showToastNotification("Failed to Delete", "error");
        dispatch(documentsActions.clearDeleteDocument());
        break;

      case -2:
        showToastNotification("Document is not available", "error");
        dispatch(documentsActions.clearDeleteDocument());
        break;

      default:
        break;
    }
  }, [deleteResponse]);

  useEffect(() => {
    if (documentList && documentList?.DataList?.length > 0) {
      const title = "Document_List";
      const generateExcelColumns = [
        "Title",
        "Created By",
        "Created On",
        "Last Modified By",
        "Last Modified On",
        "Status",
      ];

      const docList = documentList?.DataList?.map((obj) => ({
        Title: obj.DocumentTitle,
        Created_By: obj.CreatedBy,
        Created_On: obj.DocumentUploadDate,
        Last_Modified_By: obj.ModifiedBy,
        Last_Modified_On: obj.ModifiedDate,
        Status: obj.ActiveStatus,
      }));

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(docList, generateExcelColumns, title);

        // Clear excel data after the download
        dispatch(documentsActions.clearDeleteDocumentExcelList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [documentList]);

  //Get Management User Access Permission list
  useEffect(() => {
    if (commonFacilityCode === 0) return;
    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: MenuItem.DocumentsMenuItem,
      })
    );
  }, [commonFacilityCode]);

  // Management User Access Permission load
  useEffect(() => {
    if (userAccessPermission.length > 0) {
      setaccessPermission(userAccessPermission);
    }
  }, [userAccessPermission]);

  //  status onchange
  const handleStatusChange = (selectedOption) => {
    //const values = { ...documentSearch };
    const statusValue = selectedOption?.value ?? 2;
    // values.activeStatus = statusValue ?? 2;
    dispatch(
      documentsActions?.setDocumentSearch({
        ...documentSearch,
        activeStatus: statusValue,
        pageNo: 1,
        rowCountPerPage: 10,
      })
    );
  };

  const handleSearch = (e) => {
    e?.preventDefault();
    const search = { ...documentSearch };
    search.pageNo = 1;
    search.rowCountPerPage = 10;
    dispatch(documentsActions.setDocumentSearch(search));
    setisloading(true);
    dispatch(documentsActions.LoadDocumentList(search)).then((x) => { setisloading(false) });
  };

  const handleReset = () => {
    const reset = {
      title: "",
      activeStatus: 2,
      fromDate: "",
      toDate: "",
      pageNo: 1,
      rowCountPerPage: 10,
      facilityID: commonFacilityCode,
    };
    dispatch(documentsActions?.setDocumentSearch(reset));
    dispatch(documentsActions.LoadDocumentList(reset));
  };
  //grid page Onchange
  const handlePageChange = (value) => {
    if (sorting) {
      sorting = false;
      return;
    }
    dispatch(
      documentsActions?.setDocumentSearch({
        ...documentSearch,
        pageNo: value,
      })
    );
    dispatch(documentsActions.LoadDocumentList({ ...documentSearch, pageNo: value, facilityID: commonFacilityCode }));
  };
  /// Excel download
  const handleClickExcel = () => {
    const updateTotalRows = {
      ...documentSearch,
      RowCountPerPage: loaddata?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
    };

    dispatch(documentsActions.LoadDocumentList(updateTotalRows));
  };

  ///Grid Click func
  const handleDocumentClick = (row) => {
    Swal?.close();
    history.navigate("/Admin/DocumentList/Add", {
      state: { facilityCode, row },
    });
  };
  // griddata delete
  const handleDelete = (documentID, commonFacilityCode) => {
    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: MenuItem.DocumentsMenuItem,
      })
    )
      .then((res) => {
        const shouldEnableBtnDeletes =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.SubMenuName === "Delete" &&
                item?.SubMenuActiveStatus === 1
            )
            : true;
        if (!shouldEnableBtnDeletes) {
          showToastNotification(
            "Delete option has been disabled by the admin.",
            "error"
          );
          return;
        }
        const payload = {
          documentID: documentID,
          facilityID: commonFacilityCode,
          modifiedBy: user?.ManagementUserID,
        };
        if (payload) {
          Popup({
            title: "Message",
            text: `Are you sure you want to delete?`,
            icon: "info",
            confirmButtonText: "YES",
            cancelButtonText: "NO",
            onConfirm: () => {
              dispatch(documentsActions.DeleteDocument(payload));
              // Insert Management User Activity Log
              dispatch(
                authActions?.ManagementUserActivityLog({
                  ManagementUserID: user?.ManagementUserID,
                  facilityID: commonFacilityCode,
                  ProcedureName: StoredProcedures?.DocumentDelete,
                  UserAction: `Deleted a Document ( DocumentID  ${documentID})`,
                })
              );
            },
          });
        }
      })
      .catch((e) => {
        showToastNotification(
          "Failed to fetch user access permissions",
          "error"
        );
      });
  };

  const handleDocumentdownload = async (row) => {
    const documentPath = row?.DocumentPath; // Example: "/PostalMail/MS01/ps_110129.pdf"

    // Extract the folder path
    const extractedFolderPath = documentPath?.split("/").slice(1, -1).join("/");

    // Extract the file name
    const filename = documentPath?.split("/").pop();

    if (extractedFolderPath && filename) {
      try {
        setisloading(true);
        const result = await dispatch(
          masterActions.DownLoadFiles({
            filename,
            folderPath: extractedFolderPath,
          })
        ).unwrap();
        if (result.success) {
          setisloading(false)
        }
      } catch (error) {
        setisloading(false)
        showToastNotification(
          "File does not exist in the uploaded directory",
          "error"
        ); // Show error toast
      }
    } else {
      showToastNotification("Invalid document path", "error"); // Show error toast for invalid path
    }
  };

  //grid column
  const columns = [
    {
      name: "Title",
      selector: (row) => row.DocumentTitle,
      sortable: true,
      key: "DocumentTitle",
      cell: (row) => (
        <div
          onClick={() => handleDocumentClick(row)}
          className="Common_Link_Style"
        >
          {row.DocumentTitle}
        </div>
      ),
    },
    {
      name: "Created By",
      key: "DocumentUploadBy",
      selector: (row) => row.CreatedBy,
      sortable: true,
    },
    {
      name: "Created On",
      key: "DocumentUploadDate",
      selector: (row) => row.DocumentUploadDate,
      sortable: true,
    },
    {
      name: "Last Modified By",
      key: "DocumentModifiedBy",
      selector: (row) => (row.ModifiedBy ? row.ModifiedBy : "-"),
      sortable: true,
    },
    {
      name: "Last Modified On",
      key: "DocumentModifiedDate",
      selector: (row) => (row.ModifiedDate ? row.ModifiedDate : "-"),
      sortable: true,
    },
    {
      width: "80px",
      name: "Status",
      selector: (row) => row.ActiveStatus,
      key: "ActiveStatus",
      sortable: true,

      cell: (row) => (
        <div>
          <img
            title={row.ActiveStatus === "Active" ? "Active" : "Inactive"}
            src={row.ActiveStatus === "Active" ? Activeicon : Inactiveicon}
            alt={row.ActiveStatus === "Active" ? "Active" : "Inactive"}
            className="in-icon-size"
          />
        </div>
      ),
    },

    {
      width: "100px",
      name: "Action",
      selector: (row) => (
        <div className="d-flex flex-wrap gap-2">
          <img
            src={downloadicon}
            title="Download"
            aria-hidden="true"
            onClick={() => handleDocumentdownload(row)}
            className="in-icon-size cursor-pointer"
            alt="download-icon"
          />
          <img
            src={deleteicon}
            title="Delete"
            alt="Delete"
            aria-hidden="true"
            onClick={() =>
              shouldEnableBtnDelete &&
              handleDelete(row.DocumentID, commonFacilityCode)
            }
            className={`in-icon-size ${shouldEnableBtnDelete
              ? "cursor-pointer"
              : "pointer-events-none opacity-50"
              }`}
          />
        </div>
      ),
      sortable: false,

      // right: true,
      // left: true,
    },
  ];

  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...documentSearch };
    const newSortOrder = search.SortField?.includes(column.key)
      ? search.SortField.endsWith("ASC")
        ? "DESC"
        : "ASC"
      : "ASC";
    search.SortField = `${column.key} ${newSortOrder}`;
    dispatch(documentsActions?.setDocumentSearch(search));

    dispatch(
      documentsActions.LoadDocumentList({
        ...documentSearch,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const hadleDocSearchChange = (name, e) => {
    let value = e.target.value;

    if (value !== "" && value.trim() === "") {
      return;
    }
    dispatch(
      documentsActions?.setDocumentSearch({
        ...documentSearch,
        [name]: value,
      })
    );
  };

  const handleDocDateChange = (value, name) => {
    const updatedSearch = { ...documentSearch };
    const date = fDate(value);
    updatedSearch[name] = date || "";
    dispatch(documentsActions?.setDocumentSearch(updatedSearch));
  };

  //Click the Enter Btn need to select the Current Date
  const handleDateEnterKey = (event, name) => {
    const updatedSearch = { ...documentSearch };
    if (event.key === "Enter" && updatedSearch[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDocDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "fromDate") {
      if (
        documentSearch.toDate &&
        new Date(value) > new Date(documentSearch.toDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "toDate") {
      if (
        documentSearch.fromDate &&
        new Date(value) < new Date(documentSearch.fromDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...documentSearch,
      fromDate:
        fieldName === "fromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : documentSearch.fromDate, // preserve existing value
      toDate:
        fieldName === "toDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : documentSearch.toDate, // preserve existing value
    };
    dispatch(documentsActions?.setDocumentSearch(updatedParam));
  };
  // Doc upload
  const handleUpload = (e) => {
    e?.preventDefault();
    Swal?.close();
    dispatch(documentsActions.clearGetDocumentDetails());
    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: MenuItem.DocumentsMenuItem,
      })
    ).then((res) => {
      const shouldShowBtnUploads =
        Array.isArray(res?.payload) && res?.payload.length > 0
          ? res?.payload.some(
            (item) =>
              item?.SubMenuName === "Upload" &&
              item?.SubMenuActiveStatus === 1
          )
          : true;
      if (!shouldShowBtnUploads) {
        showToastNotification(
          "Upload option has been disabled by the admin.",
          "error"
        );
        return;
      }
      history.navigate("/Admin/DocumentList/Add", { state: { facilityCode } });
    });
  };
  // grid row changes
  const RowsCountPerPage = (value) => {
    dispatch(
      documentsActions?.setDocumentSearch({
        ...documentSearch,
        rowCountPerPage: value,
        pageNo: 1,
      })
    );
    dispatch(documentsActions.LoadDocumentList({ ...documentSearch, pageNo: 1, facilityID: commonFacilityCode, rowCountPerPage: value }));
  };

  if (loading || isloading) {
    return <CustomLoader />;
  }

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form>
        <div className="row ">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-floating mb-3">
              <TextInput
                name="title"
                label="Title"
                value={documentSearch?.title}
                handleChange={(e) => hadleDocSearchChange("title", e)}
                placeholder="Title"
                maxLength={50}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-floating mb-3">
              <SelectInput
                name="activeStatus"
                label="Status"
                options={podStatusOptions}
                value={documentSearch?.activeStatus}
                handleChange={handleStatusChange}
                isMulti={false}
                isClearable={documentSearch?.activeStatus !== 2}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-floating mb-3">
              <DateInput
                label="From Date"
                name="fromDate"
                value={documentSearch?.fromDate}
                maxDate={
                  documentSearch?.toDate ? documentSearch?.toDate : new Date()
                }
                isClearable={
                  documentSearch.fromDate !== null &&
                  documentSearch.fromDate !== ""
                }
                handleChange={(e) => handleDocDateChange(e, "fromDate")}
                placeholderText="Select a date"
                minDate={new Date(2017, 0, 1)}
                handleBlur={(e) => handleDateBlur(e, "fromDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "fromDate")}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="form-floating mb-3">
              <DateInput
                label="To Date"
                name="toDate"
                value={documentSearch?.toDate}
                //minDate={documentSearch?.fromDate}
                minDate={
                  documentSearch?.fromDate
                    ? new Date(
                      Math.max(
                        new Date(2017, 0, 1),
                        new Date(documentSearch?.fromDate)
                      )
                    )
                    : new Date(2017, 0, 1)
                }
                maxDate={new Date()}
                isClearable={
                  documentSearch?.toDate !== null &&
                  documentSearch?.toDate !== ""
                }
                handleChange={(e) => handleDocDateChange(e, "toDate")}
                placeholderText="Select a date"
                handleBlur={(e) => handleDateBlur(e, "toDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "toDate")}
              />
            </div>
          </div>
        </div>
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            className="me-2"
            label="Search"
            type="submit"
            onClick={handleSearch}
            icon={"search"}
            variant="danger"
            status={"primary"}
            disabled={false}
          />

          <Button
            className="me-2"
            label="Reset"
            type="button"
            onClick={handleReset}
            variant="primary "
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
        {commonFacilityCode > 0 && (
          <div className="card  shadow-sm b-r-all  p-4 border border-dark-grey mt-3  w-100">
            <div className=" d-block d-md-none">
              <div
                className=" d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h2 className="form_title_uppercase text-color">
                  Document SEARCH
                </h2>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {/* Mobile only (Below md breakpoint) */}
            <div className="d-block d-md-none mt-2">
              {showSearchFields && renderSearch()}
            </div>

            {/* Web only (Desktop and above) */}
            <div className="mb-3 d-none d-md-block">
              <h2 className="form_title_uppercase text-color">
                Document SEARCH
              </h2>
            </div>
            {/* Web only (Desktop and above) */}
            <div className="d-none d-md-block">{renderSearch()}</div>
          </div>
        )}

        {commonFacilityCode > 0 ? (
          <div className=" shadow-sm b-r-all card  p-4 border border-dark-grey mt-3 w-100 mb-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 resp-space">
              <h2 className="form_title_uppercase text-color">
                DOCUMENTS LIST
              </h2>
              <div className="d-flex flex-wrap gap-3 justify-content-end">
                {shouldShowBtnUpload && (
                  <Button
                    className="me-2"
                    label="Upload"
                    type="button"
                    onClick={handleUpload}
                    variant="danger"
                    status="btn-label"
                    // icon={"circle-plus"}
                    imgsrc={uploadicon}
                    disabled={false}
                  />
                )}

                {loaddata?.DataList?.length > 0 ? (
                  <ExcelExport
                    variant="soft-gray"
                    handleExcelExport={handleClickExcel}
                  />
                ) : null}
              </div>
            </div>
            <Table
              columns={columns}
              data={loaddata?.DataList}
              totalRowCount={loaddata?.TotalRecordCount}
              pagination={true}
              currentPage={documentSearch?.pageNo}
              paginationPerPage={documentSearch?.rowCountPerPage}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={RowsCountPerPage}
              onSort={handleSort}
              serverSideSort
              sortColumn={documentSearch?.SortField?.split(" ")[0]}
              sortDirection={documentSearch?.SortField?.split(" ")[1]}
            />
          </div>
        ) : (
          <h4 className="facility-card">
            Select a Facility Code from the list
          </h4>
        )}
      </div>
    </div>
  );
}

export default React.memo(Documents);
